import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface ActionBarContextValue {
  actionBar: ReactNode;
  setActionBar: (node: ReactNode) => void;
}

const ActionBarContext = createContext<ActionBarContextValue | null>(null);

export function ActionBarProvider({ children }: { children: ReactNode }) {
  const [actionBar, setActionBar] = useState<ReactNode>(null);
  const value = useMemo(() => ({ actionBar, setActionBar }), [actionBar]);
  return (
    <ActionBarContext.Provider value={value}>
      {children}
    </ActionBarContext.Provider>
  );
}

export function useActionBarValue(): ReactNode {
  return useContext(ActionBarContext)?.actionBar ?? null;
}

export function useActionBarSetter(): (node: ReactNode) => void {
  const ctx = useContext(ActionBarContext);
  if (!ctx) {
    throw new Error('useActionBarSetter must be used within an ActionBarProvider');
  }
  return ctx.setActionBar;
}
